exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-header-image {\r\n  background-image: url('https://material.angular.io/assets/img/examples/shiba1.jpg');\r\n  background-size: cover;\r\n  width: 100%;\r\n}\r\n\r\n.project-icon {\r\n  font-size: 4em;\r\n  padding: 0 !important;\r\n  color: #fff\r\n}\r\n\r\n.project-icon:hover {\r\n  text-shadow: 3px 3px 0px rgba(255,255,255, 0.5);\r\n}\r\n\r\nmat-card-title {\r\n  color: whitesmoke;\r\n  font-size: 1.5em;\r\n  font-weight: 700;\r\n  margin-bottom: 3px;\r\n}\r\n\r\nmat-card-subtitle {\r\n  margin: 0;\r\n  color: whitesmoke;\r\n  font-weight: 200;\r\n}\r\n\r\nmat-card-title:hover{\r\n  text-decoration: underline;\r\n}\r\n\r\nmat-card-content>p {\r\n  color: whitesmoke;\r\n  font-size: 1em;\r\n  font-weight: 500;\r\n}\r\n\r\n.project-item {\r\n  height: 100%;\r\n  margin: 10px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/displayer/project-item/project-item.component.css
// module id = ../../../../../src/app/displayer/project-item/project-item.component.css
// module chunks = main